// extracted by extract-css-chunks-webpack-plugin
module.exports = {"company":"company_2_Q6s","illus":"illus_15xg4","title":"title_3xljD","bar":"bar_3AXEE","bar_wrap":"bar_wrap_2TCWy","desc":"desc_m_o__","desc_wrap":"desc_wrap_ofr87"};